import { gql, TypedDocumentNode, useQuery } from '@apollo/client';
import { GetOptimizationFileListQuery, QueryOptimizationFileListArgs } from '../../generated/graphql';

export const optimizationFileListQuery: TypedDocumentNode<GetOptimizationFileListQuery, QueryOptimizationFileListArgs> =
  gql`
    query GetOptimizationFileList($contractPartnerIds: [String!]!) {
      optimizationFileList(contractPartnerIds: $contractPartnerIds) {
        files
        modelNamesWithoutFiles
      }
    }
  `;

export interface UseOptimizationListResults {
  files: readonly string[] | [];
  modelNamesWithoutFiles: readonly string[] | [];
  loading: boolean;
}

export function useOptimizationList(contractPartnerIds: string[]): UseOptimizationListResults {
  const { data, loading } = useQuery(optimizationFileListQuery, { variables: { contractPartnerIds } });
  return {
    files: data?.optimizationFileList.files ?? [],
    modelNamesWithoutFiles: data?.optimizationFileList.modelNamesWithoutFiles ?? [],
    loading,
  };
}
